export const IconLoaderGrayNormal: {
  name: 'icon_loader_gray_normal-e167b63a3817'
} = {
  name: 'icon_loader_gray_normal-e167b63a3817'
}
